module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c(_vm.controlComponent, _vm._b({
    tag: "component",
    on: {
      "input": function($event) {
        _vm.updateVal($event)
      }
    },
    model: {
      value: (_vm.field.val),
      callback: function($$v) {
        _vm.$set(_vm.field, "val", $$v)
      },
      expression: "field.val"
    }
  }, 'component', _vm.fieldData, false))
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2c7de279", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c7de279","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sib-website/assets/src/js/app/vue/components/cms-plugins/sib-form/form-field-control/index.vue
// module id = 524
// module chunks = 7